import { render, staticRenderFns } from "./DomainList.vue?vue&type=template&id=30c81292&scoped=true"
import script from "./DomainList.vue?vue&type=script&lang=js"
export * from "./DomainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c81292",
  null
  
)

export default component.exports